import { ClientResource } from "src/app/interfaces/client-resources";

export const ClientResources : ClientResource[] = 
   [
    {
        // default
        clientId: 0,
        pages: 
        [
            {      
                page: "claim",
                id: null,
                url : "claims/claim"
            },
            {      
                page: "invoice",
                id: null,
                url : "claims/invoice"
            },
            {
                page: "vehicle",
                id: null,
                url : "claims/vehicle",
                content : 
                [
                    { component:"root-menu", "visible":true }
                ]
            }   
        ],
    },
    {
        // kmt
        clientId: 9122,
        pages: 
        [
            {      
                page: "claim",
                id: "CLAIMTYPEID-60",
                url : "kmt/tollticket"
            },
            {      
                page: "invoice",
                id: 'INVOICETYPEID-1',
                url : "kmt/penalty"
            },
            {
                page: "vehicle",
                id: null,
                url : "claims/vehicle",
                content : 
                [
                    { component:"root-menu", "visible":false }
                ]
            } 
        ]
    }
];

